import { Injectable } from '@angular/core';

@Injectable()
export class HelperService {
	public parseJsonString = (str: string) => JSON.parse(str.replace(/\&quot;/g, '"'));
}


// WEBPACK FOOTER //
// ./src/services/helper.service.ts